import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { camelizeKeys, pascalizeKeys } from 'humps';

export * from 'axios';
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true
});

api.interceptors.response.use((response: AxiosResponse) => {
    if (
        response.data &&
        response.headers['content-type'].includes('application/json')
    ) {
        response.data = camelizeKeys(response.data);
    }
    return response;
});

api.interceptors.request.use((config: AxiosRequestConfig) => {
    const newConfig = { ...config };

    if (config.data) {
        newConfig.data = pascalizeKeys(config.data);
    }
    return newConfig;
});

export default api;
